module.exports = __webpack_public_path__ + "img/snapping_fingers_to_turn_off_flashlight.7b1011a5.jpg";